const abidePatchedURLPattern = {
  test: function(inputText) {
    try {
      new URL(inputText);
      return true
    } catch (e) {
      if (e instanceof TypeError) {
        return false
      } else {
        throw e;
      }
    }
  }
}

export default abidePatchedURLPattern
